import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { EligibilityRuleSet } from 'se-resource-types/dist/lib/MembershipService'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class EligibilityRuleSetService {

  public endpoint = 'eligibility_rule_sets'

  constructor(private api: ApiService) {
    // noop
  }

  public findAll(membershipDefinitionId: string, bossOrganizationId: number): Observable<EligibilityRuleSet[]> {
    return this.api.get(
      this.endpoint,
      { params: { boss_organization_id: bossOrganizationId, membership_definition_id: membershipDefinitionId } })
        .pipe(
          first(),
          map(data => data.result),
        )
  }
}
